<template>
	<div v-loading="loading" class="base_scroll_page" style="padding: 15px 15px 15px 200px">
		<!-- 区域选择 -->
		<AreaChoise @nodeClick="handleAreaChoiseSelect"></AreaChoise>
		<!-- 区域选择 end -->

		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">代理商名称：</span>
					<el-input v-model="agent_name" class="b_inp" placeholder="代理商名称"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">创建人：</span>
					<el-input v-model="agent_creater" class="b_inp" placeholder="创建人"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="agent_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					></el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="agent_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					></el-date-picker>
				</div>

				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->

			<!-- action -->
			<div style="margin-top: 20px; font-size: 0; text-align: right">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddAgentClick">新增代理商</el-button>
			</div>
			<!-- action end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px">
				<el-table :data="tableData" style="width: 100%" @selection-change="handleTableSelectionChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="name" label="代理商名称"></el-table-column>
					<el-table-column prop="code" label="编码"></el-table-column>
					<el-table-column prop="creater" label="创建人"></el-table-column>
					<el-table-column prop="creatDate" label="创建时间"></el-table-column>
					<el-table-column label="操作" width="440">
						<template slot-scope="scope">
							<el-button @click="handleViewAgentClick(scope.row)">查看</el-button>
							<el-button @click="handleUpdateAgentClick(scope.row)">修改</el-button>
							<el-button @click="handleManageAgentClick(scope.row)">管理员</el-button>
							<el-button @click="handleRechargeAgentClick(scope.row)">充值</el-button>
							<el-button @click="handleAgentConsumeCountClick(scope.row)">消费统计</el-button>
							<el-button @click="handleAgentRechargeRecordClick(scope.row)">充值记录</el-button>
							<el-button @click="handleAgentConsumeRecordClick(scope.row)">消费记录</el-button>
							<el-button @click="deleteProxy(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px">
				<!-- 	<div style="float: left">
					<el-button type="danger" @click="handleBatchDeleteClick">批量删除</el-button>
				</div> -->
				<div class="base_pager" style="float: right">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页"
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					></el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->

		<!-- 新增代理商弹出框 -->
		<Popup v-model="addAgent_popup_display" title="新增代理商" confirmBtnText="添加" @confirmClick="handleAddAgentPopupConfirmClick">
			<div v-loading="add_loading" style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						名称
					</span>
					<el-input v-model="addAgent_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addAgentName_tip">
						<i class="b_icon"></i>
						请输入代理商名称
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">备注</span>
					<el-input v-model="addAgent_desc" placeholder="备注"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						所属区域
					</span>
					<VDistpicker @province="handleAddAgentAddrProvinceSelect" @city="handleAddAgentAddrCitySelect" @area="handleAddAgentAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="addAgentAddr_tip">
						<i class="b_icon"></i>
						请选择区域
					</template>
				</div>
				<div style="padding: 15px; border: 1px dashed #ccc; border-radius: 10px">
					<h1 style="font-size: 16px; color: #5f6468; text-align: center; line-height: 36px">默认代理用户</h1>
					<div class="base_form_row" style="margin-top: 20px">
						<span class="b_label">
							<span style="color: #f00">*</span>
							姓名
						</span>
						<el-input v-model="addProxyer_name" placeholder="姓名"></el-input>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px">
						<template v-if="addProxyerName_tip">
							<i class="b_icon"></i>
							请输入姓名
						</template>
					</div>
					<div class="base_form_row">
						<span class="b_label">
							<span style="color: #f00">*</span>
							手机号
						</span>
						<el-input v-model="addProxyer_phone" placeholder="手机号"></el-input>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px">
						<template v-if="addProxyerPhone_tip">
							<i class="b_icon"></i>
							手机号格式错误
						</template>
					</div>
					<div class="base_form_row">
						<span class="b_label">
							<span style="color: #f00">*</span>
							擅长
						</span>
						<div class="b_checkbox_group">
							<el-checkbox-group v-model="addProxyer_special">
								<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px">
						<template v-if="addProxyerSpecial_tip">
							<i class="b_icon"></i>
							至少勾选一项
						</template>
					</div>
				</div>
			</div>
		</Popup>
		<!-- 新增代理商弹出框 end -->

		<!-- 查看代理商弹出框 -->
		<Popup v-model="viewAgent_popup_display" title="代理商详情" :confirmBtnDisplay="false">
			<div style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">编码</span>
					<el-input :value="viewAgent_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">名称</span>
					<el-input :value="viewAgent_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">所属区域</span>
					<div class="b_select">
						<el-select :value="viewAgent_addr.provinceName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewAgent_addr.cityName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewAgent_addr.areaName" disabled></el-select>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">备注</span>
					<el-input :value="viewAgent_desc" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">创建人</span>
					<el-input :value="viewAgent_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">创建时间</span>
					<el-input :value="viewAgent_creatDate" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">修改人</span>
					<el-input :value="viewAgent_updater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">修改时间</span>
					<el-input :value="viewAgent_updateDate" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看代理商弹出框 end -->

		<!-- 修改代理商弹出框 -->
		<Popup v-model="updateAgent_popup_display" title="更新代理商" @confirmClick="handleUpdateAgentPopupConfirmClick">
			<div style="padding: 15px">
				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						编码
					</span>
					<el-input :value="updateAgent_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						名称
					</span>
					<el-input v-model="updateAgent_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateAgentName_tip">
						<i class="b_icon"></i>
						请输入代理商名称
					</template>
				</div>
				<div class="base_form_row">
					<span class="b_label">备注</span>
					<el-input v-model="updateAgent_desc" placeholder="备注"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						所属区域
					</span>
					<VDistpicker
						:province="updateAgent_addr.provinceName"
						:city="updateAgent_addr.cityName"
						:area="updateAgent_addr.areaName"
						@province="handleUpdateAgentAddrProvinceSelect"
						@city="handleUpdateAgentAddrCitySelect"
						@area="handleUpdateAgentAddrAreaSelect"
					></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="updateAgentAddr_tip">
						<i class="b_icon"></i>
						请选择区域
					</template>
				</div>
			</div>
		</Popup>
		<!-- 修改代理商弹出框 end -->

		<!-- 删除代理商弹出框 -->
		<Popup v-model="deleteAgent_popup_display" title="提示" @confirmClick="handleDeleteAgentPopupConfirmClick">
			<div style="padding: 15px">
				<p style="color: #5f6468; line-height: 24px">您确认要删除吗？</p>
			</div>
		</Popup>
		<!-- 删除代理商弹出框 end -->

		<!-- 代理商管理员弹出框 -->
		<Manager v-model="manageAgent_popup_display" :id="manageAgent_id"></Manager>
		<!-- 代理商管理员弹出框 end -->

		<!-- 充值弹出框 -->
		<Recharge
			v-model="rechargeAgent_popup_display"
			:id="rechargeAgent_id"
			:name="rechargeAgent_name"
			:code="rechargeAgent_code"
			:products="authProduct"
			:objectType="1"
			:powerInfo='powerInfo'
			@success="handleRechargeSuccess"
			
		></Recharge>
		<!-- 充值弹出框 end -->

		<!-- 消费统计弹出框 -->
		<ConsumeCount v-model="agentConsumeCount_popup_display" :id="agentConsumeCount_id"></ConsumeCount>
		<!-- 消费统计弹出框 end -->

		<!-- 充值记录弹出框 -->
		<RechargeRecord v-model="agentRechargeRecord_popup_display" :id="agentRechargeRecord_id" :code="agentRechargeRecord_code" type="1"></RechargeRecord>
		<!-- 充值记录弹出框 end -->

		<!-- 消费记录弹出框 -->
		<ConsumeRecord v-model="agentConsumeRecord_popup_display" :id="agentConsumeRecord_id" :code="agentConsumeRecord_code" type="1"></ConsumeRecord>
		<!-- 消费记录弹出框 end -->
	</div>
</template>

<script>
import AreaChoise from '../components/area_choise.vue';
import Api from '../../../../api/index.js';
import BaseMethods from '../../../../assets/js/base.js';
import { mapState,mapGetters } from 'vuex';
import Manager from './components/manager.vue';
import Recharge from './components/recharge.vue';
import ConsumeCount from './components/consume_count.vue';
import RechargeRecord from './components/recharge_record.vue';
import ConsumeRecord from './components/consume_record.vue';

export default {
	data() {
		return {
			loading: false,
			tableData: [],

			currentPage: 1,
			total: 0,

			agent_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			agent_name: '',
			agent_creater: '',
			agent_startTime: '',
			agent_endTime: '',

			add_loading: false,
			addAgent_popup_display: false,
			addAgent_name: '',
			addAgent_desc: '',
			addAgent_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			addAgentName_tip: false,
			addAgentAddr_tip: false,

			addProxyer_name: '',
			addProxyer_phone: '',
			addProxyer_special: [],
			addProxyerName_tip: false,
			addProxyerPhone_tip: false,
			addProxyerSpecial_tip: false,

			viewAgent_popup_display: false,
			viewAgent_code: '',
			viewAgent_name: '',
			viewAgent_addr: {
				provinceName: '',
				cityName: '',
				areaName: ''
			},
			viewAgent_desc: '',
			viewAgent_creater: '',
			viewAgent_creatDate: '',
			viewAgent_updater: '',
			viewAgent_updateDate: '',

			updateAgent_popup_display: false,
			updateAgent_id: '',
			updateAgent_code: '',
			updateAgent_name: '',
			updateAgent_desc: '',
			updateAgent_addr: {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			},
			updateAgentName_tip: false,
			updateAgentAddr_tip: false,

			deleteAgent_popup_display: false,
			deleteAgent_ids: '',

			manageAgent_popup_display: false,
			manageAgent_id: '',

			rechargeAgent_popup_display: false,
			rechargeAgent_id: '',
			rechargeAgent_name: '',
			rechargeAgent_code: '',

			agentConsumeCount_popup_display: false,
			agentConsumeCount_id: '',

			agentRechargeRecord_popup_display: false,
			agentRechargeRecord_id: '',
			agentRechargeRecord_code: '',

			agentConsumeRecord_popup_display: false,
			agentConsumeRecord_id: '',
			agentConsumeRecord_code: ''
		};
	},
	computed: {
		...mapState(['authInfo', 'authProduct', 'allDisease']),...mapGetters (['powerInfo'])
	},
	mounted() {
		this.getOrganizationList();
	},
	methods: {
		/************************ @Ajax *******************************/
		// 请求数据
		getOrganizationList() {
			const that = this;
			that.loading = true;
			var _requestData = {
				endTime: that.agent_startTime,
				founderName: that.agent_creater,
				hosptialName: that.agent_name,
				limit: 10,
				pageNum: that.currentPage,
				startTime: that.agent_endTime,
				uareaName: that.agent_addr.areaName,
				ucategoryLogin: that.authInfo.ucategory,
				ucityName: that.agent_addr.cityName,
				ufinderCategory: 1,
				uid: null,
				uprovinceName: that.agent_addr.provinceName,
				warning: null,
				userId: that.authInfo.uid,
				uenterpriseId: that.authInfo.uenterpriseId,
				functionType: 1
			};
			Api.findOrganization(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.total;
						that.tableData = [];
						for (var i = 0; i < res.data.data.list.length; i++) {
							that.tableData.push({
								id: res.data.data.list[i].uenterpriseId,
								name: res.data.data.list[i].uenterpriseName || '',
								code: res.data.data.list[i].ucode || '',
								creater: res.data.data.list[i].founderName || '',
								creatDate: res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split('T')[0] : '',
								provinceName: res.data.data.list[i].uprovinceName || '',
								provinceCode: res.data.data.list[i].uprovinceCode || '',
								cityName: res.data.data.list[i].ucityName || '',
								cityCode: res.data.data.list[i].ucityCode || '',
								areaName: res.data.data.list[i].uareaName || '',
								areaCode: res.data.data.list[i].uareaCode || '',
								updater: res.data.data.list[i].updaterName || '',
								updateDate: res.data.data.list[i].updateTime ? res.data.data.list[i].updateTime.split('T')[0] : '',
								desc: res.data.data.list[i].usynopsis || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 删除组织数据
		deleteOrganization(ids) {
			const that = this;
			that.loading = true;
			var _requestData = {
				uId: ids
			};
			console.log(_requestData);
			Api.deleteOrganization(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取充值记录
		getRechargeRecord() {
			const that = this;
			that.loading = true;
			var _requestData = {
				endTime: '',
				id: null,
				limit: 10,
				oneCategory: 1,
				pageNum: that.agentRechargeRecord_page,
				startTime: '',
				twoCategory: 0,
				type: 1,
				ucode: that.agentRechargeRecord_code,
				uenterpriseId: that.agentRechargeRecord_id,
				versionFlag: null
			};
			Api.getOrganizationConsumeRecord(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.agentRechargeRecord_total = res.data.data.totalItems;
						that.agentRechargeRecord_data = [];
						var _data = res.data.data.data;
						for (var i = 0; i < _data.length; i++) {
							for (var ii = 0; ii < that.authProduct.length; ii++) {
								if (_data[i].uversionFlag == that.authProduct[ii].id) {
									var _action = '',
										_o = {};
									if (_data[i].ucategory == 1) {
										_action = '充值';
									} else if (_data[i].ucategory == 2) {
										_action = '赠送';
									} else if (_data[i].ucategory == 3) {
										_action = '扣除返还';
									}
									_o.date = _data[i].ucreateTs ? _data[i].ucreateTs.split(' ')[0] : '';
									_o.action = _action;
									_o.operated = _data[i].operator ? _data[i].operator : '/';
									_o.product = that.authProduct[ii].name;
									_o.detail = _data[i].utime;
									_o.operater = _data[i].username ? _data[i].username : '/';
									that.agentRechargeRecord_data.push(_o);
								}
							}
						}
						that.agentRechargeRecord_popup_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 获取消费记录
		getConsumeRecord() {
			const that = this;
			that.loading = true;
			var _requestData = {
				endTime: '',
				id: null,
				limit: 10,
				oneCategory: 2,
				pageNum: that.agentConsumeRecord_page,
				startTime: '',
				twoCategory: 0,
				type: 1,
				ucode: that.agentConsumeRecord_code,
				uenterpriseId: that.agentConsumeRecord_id,
				versionFlag: null
			};
			Api.getOrganizationConsumeRecord(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.agentConsumeRecord_total = res.data.data.totalItems;
						that.agentConsumeRecord_data = [];
						var _data = res.data.data.data;
						for (var i = 0; i < _data.length; i++) {
							for (var ii = 0; ii < that.authProduct.length; ii++) {
								if (_data[i].uversionFlag == that.authProduct[ii].id) {
									var _action = '',
										_o = {};
									if (_data[i].ucategory == 1) {
										_action = '正常消费划拨';
									} else if (_data[i].ucategory == 2) {
										_action = '赠送';
									} else if (_data[i].ucategory == 3) {
										_action = '扣除';
									}
									_o.date = _data[i].ucreateTs ? _data[i].ucreateTs.split(' ')[0] : '';
									_o.action = _action;
									_o.operated = _data[i].operator ? _data[i].operator : '/';
									_o.product = that.authProduct[ii].name;
									_o.detail = _data[i].utime;
									_o.operater = _data[i].username ? _data[i].username : '/';
									that.agentConsumeRecord_data.push(_o);
								}
							}
						}
						that.agentConsumeRecord_popup_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 新增代理商
		addAgent() {
			const that = this;
			that.add_loading = true;
			var requestData = {
				openNewMechanismVo: {
					uaddress: null,
					uareaCode: that.addAgent_addr.areaCode,
					uareaName: that.addAgent_addr.areaName,
					ucategory: 1,
					ucityCode: that.addAgent_addr.cityCode,
					ucityName: that.addAgent_addr.cityName,
					ucode: null,
					ucreate: null,
					ucreateTs: null,
					udeviceNos: null,
					udoubleTaskPeriod: 0,
					udr: 0,
					uid: null,
					uisBackstage: 0,
					uisCard: 0,
					uisSuperiorsPay: 0,
					umemo: null,
					uname: that.addAgent_name,
					unationalityCode: null,
					unationalityName: null,
					uoperateTime: null,
					uphone: null,
					uphoto: null,
					upollCode: null,
					uprovinceCode: that.addAgent_addr.provinceCode,
					uprovinceName: that.addAgent_addr.provinceName,
					uqualifications: null,
					usynopsis: that.addAgent_desc,
					utel: null,
					utypeId: null,
					uupdate: null,
					uupdateTs: null,
					uvsersionStatus: 0
				},
				openUmBUserVo: {
					isExamine: null,
					password: null,
					uareaCode: that.addAgent_addr.areaCode,
					uareaName: that.addAgent_addr.areaName,
					ucategory: 2,
					ucategorySpecific: null,
					ucityCode: that.addAgent_addr.cityCode,
					ucityName: that.addAgent_addr.cityName,
					ucode: that.addProxyer_phone,
					ucreate: null,
					ucreateTs: null,
					uenterpriseId: null,
					uexpert: that.addProxyer_special.join(','),
					uid: null,
					ulevel: null,
					uname: that.addProxyer_name,
					unationalityCode: null,
					unationalityName: null,
					unionid: null,
					uphone: that.addProxyer_phone,
					uprovinceCode: that.addAgent_addr.provinceCode,
					uprovinceName: that.addAgent_addr.provinceName,
					usex: null
				},
				type: 'b',
				ucode: that.authInfo.ucode,
				uid: null
			};
			Api.addOrganization(requestData).then(
				(res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.addAgent_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				}
			);
		},
		/************************ @Events *******************************/
		// 选择城市
		handleAreaChoiseSelect(data) {
			if (data.sign == 'P') {
				this.agent_addr.provinceCode = data.key.slice(0, 3);
				this.agent_addr.provinceName = data.label;
				this.agent_addr.cityCode = '';
				this.agent_addr.cityName = '';
				this.agent_addr.areaCode = '';
				this.agent_addr.areaName = '';
				this.currentPage = 1;
				this.getOrganizationList();
			} else if (data.sign == 'C') {
				this.agent_addr.provinceCode = data.parentKey.slice(0, 3);
				this.agent_addr.provinceName = data.parentLabel;
				this.agent_addr.cityCode = data.key + '000000';
				this.agent_addr.cityName = data.label;
				this.agent_addr.areaCode = '';
				this.agent_addr.areaName = '';
				this.currentPage = 1;
				this.getOrganizationList();
			} else if (data.sign == 'A') {
				this.agent_addr.provinceCode = data.grandKey.slice(0, 3);
				this.agent_addr.provinceName = data.grandLabel;
				this.agent_addr.cityCode = data.parentKey + '000000';
				this.agent_addr.cityName = data.parentLabel;
				this.agent_addr.areaCode = data.key + '000000';
				this.agent_addr.areaName = data.label;
				this.currentPage = 1;
				this.getOrganizationList();
			} else {
				this.agent_addr.provinceCode = '';
				this.agent_addr.provinceName = '';
				this.agent_addr.cityCode = '';
				this.agent_addr.cityName = '';
				this.agent_addr.areaCode = '';
				this.agent_addr.areaName = '';
				this.currentPage = 1;
				this.getOrganizationList();
			}
		},
		// 切换查询时间
		handleSearchStartTimeClick() {
			this.compareSearchTime();
		},
		// 切换查询时间
		handleSearchEndTimeClick() {
			this.compareSearchTime();
		},
		// 点击查询
		handleSearchClick() {
			this.currentPage = 1;
			this.getOrganizationList();
		},
		// 点击页码
		handlePageChange(page) {
			if (this.currentPage != page) {
				this.currentPage = page;
				this.getOrganizationList();
			}
		},
		// 导出Excel数据
		exportExcel() {
			const that = this;
			that.loading = true;
			var requestData = {
				endTime: that.agent_endTime,
				founderName: that.agent_creater,
				hosptialName: that.agent_name,
				limit: 10000,
				pageNum: 1,
				startTime: that.agent_startTime,
				uareaName: that.agent_addr.areaName,
				ucategoryLogin: that.authInfo.ucategory,
				ucityName: that.agent_addr.cityName,
				ufinderCategory: 1,
				uid: null,
				uprovinceName: that.agent_addr.provinceName,
				warning: null,
				userId: that.authInfo.uid,
				uenterpriseId: that.authInfo.uenterpriseId,
				functionType: 2
			};
			Api.findOrganization(requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,代理商名称,编码,地区,创建人,创建时间,\n';
						for (var i = 0; i < res.data.data.list.length; i++) {
							str += `${i + 1},${res.data.data.list[i].uenterpriseName || ''},${res.data.data.list[i].ucode || ''}\t,${res.data.data.list[i].uprovinceName || ''} ${res.data.data.list[i].ucityName||''} ${res.data.data.list[i].uareaName||''},${res.data.data.list[i].founderName || ''},${
								res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split('T')[0] : ''
							}\t,\n`;
							// data.push({
							// 	name: res.data.data.list[i].uenterpriseName || '',
							// 	code: res.data.data.list[i].ucode || '',
							// 	creater: res.data.data.list[i].founderName || '',
							// 	creatDate: res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split("T")[0] : ''
							// });
						}
						console.log(str);
						BaseMethods.outputExcel(str, '代理商管理');
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		// 点击新增代理商
		handleAddAgentClick() {
			this.addAgent_name = '';
			this.addAgent_desc = '';
			this.addAgent_addr = {
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: ''
			};
			this.addAgentName_tip = false;
			this.addAgentAddr_tip = false;

			this.addProxyer_name = '';
			this.addProxyer_phone = '';
			this.addProxyer_special = [];
			this.addProxyerName_tip = false;
			this.addProxyerPhone_tip = false;
			this.addProxyerSpecial_tip = false;

			this.addAgent_popup_display = true;
		},
		// 新增代理商地址省份选择
		handleAddAgentAddrProvinceSelect(data) {
			this.addAgent_addr.provinceName = data.code ? data.value : '';
			this.addAgent_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
		},
		// 新增代理商地址城市选择
		handleAddAgentAddrCitySelect(data) {
			this.addAgent_addr.cityName = data.code ? data.value : '';
			this.addAgent_addr.cityCode = data.code ? `${data.code}000000` : '';
		},
		// 新增代理商地址区域选择
		handleAddAgentAddrAreaSelect(data) {
			this.addAgent_addr.areaName = data.code ? data.value : '';
			this.addAgent_addr.areaCode = data.code ? `${data.code}000000` : '';
		},
		// 点击新增代理商弹框添加按钮
		handleAddAgentPopupConfirmClick() {
			const that = this;
			if (!that.addAgent_name.trim()) {
				that.addAgentName_tip = true;
				return false;
			} else {
				that.addAgentName_tip = false;
			}
			if (!that.addAgent_addr.areaCode) {
				that.addAgentAddr_tip = true;
				return false;
			} else {
				that.addAgentAddr_tip = false;
			}
			if (!that.addProxyer_name.trim()) {
				// 校验姓名
				that.addProxyerName_tip = true;
				return false;
			} else {
				that.addProxyerName_tip = false;
			}
			if (!that.phoneReg.test(that.addProxyer_phone)) {
				// 校验手机号
				that.addProxyerPhone_tip = true;
				return false;
			} else {
				that.addProxyerPhone_tip = false;
			}
			if (!that.addProxyer_special.length) {
				// 校验擅长
				that.addProxyerSpecial_tip = true;
				return false;
			} else {
				that.addProxyerSpecial_tip = false;
			}
			that.addAgent();
		},
		// 点击查看
		handleViewAgentClick(data) {
			this.viewAgent_code = data.code;
			this.viewAgent_name = data.name;
			this.viewAgent_addr.provinceName = data.provinceName;
			this.viewAgent_addr.cityName = data.cityName;
			this.viewAgent_addr.areaName = data.areaName;
			this.viewAgent_creater = data.creater;
			this.viewAgent_creatDate = data.creatDate;
			this.viewAgent_updater = data.updater;
			this.viewAgent_updateDate = data.updateDate;
			this.viewAgent_popup_display = true;
		},
		// 点击修改
		handleUpdateAgentClick(data) {
			this.updateAgent_id = data.id;
			this.updateAgent_code = data.code;
			this.updateAgent_name = data.name;
			this.updateAgent_addr.provinceName = data.provinceName;
			this.updateAgent_addr.provinceCode = data.provinceCode;
			this.updateAgent_addr.cityName = data.cityName;
			this.updateAgent_addr.cityCode = data.cityCode;
			this.updateAgent_addr.areaName = data.areaName;
			this.updateAgent_addr.areaCode = data.areaCode;
			this.updateAgent_desc = data.desc;
			this.updateAgentName_tip = false;
			this.updateAgentAddr_tip = false;
			this.updateAgent_popup_display = true;
		},
		// 修改代理商地址省份选择
		handleUpdateAgentAddrProvinceSelect(data) {
			this.updateAgent_addr.provinceName = data.code ? data.value : '';
			this.updateAgent_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
		},
		// 修改代理商地址城市选择
		handleUpdateAgentAddrCitySelect(data) {
			this.updateAgent_addr.cityName = data.code ? data.value : '';
			this.updateAgent_addr.cityCode = data.code ? `${data.code}000000` : '';
		},
		// 修改代理商地址区域选择
		handleUpdateAgentAddrAreaSelect(data) {
			this.updateAgent_addr.areaName = data.code ? data.value : '';
			this.updateAgent_addr.areaCode = data.code ? `${data.code}000000` : '';
		},
		// 点击修改弹框更新
		handleUpdateAgentPopupConfirmClick() {
			const that = this;
			if (!that.updateAgent_name.trim()) {
				that.updateAgentName_tip = true;
				return false;
			} else {
				that.updateAgentName_tip = false;
			}
			if (!that.updateAgent_addr.areaCode) {
				that.updateAgentAddr_tip = true;
				return false;
			} else {
				that.updateAgentAddr_tip = false;
			}
			that.loading = true;
			var _requestData = {
				openNewMechanismVo: {
					uaddress: null,
					uareaCode: that.updateAgent_addr.areaCode,
					uareaName: that.updateAgent_addr.areaName,
					ucategory: 1,
					ucityCode: that.updateAgent_addr.cityCode,
					ucityName: that.updateAgent_addr.cityName,
					ucode: null,
					ucreate: null,
					ucreateTs: null,
					udeviceNos: null,
					udoubleTaskPeriod: 0,
					udr: 0,
					uid: that.updateAgent_id,
					uisBackstage: 0,
					uisCard: 0,
					uisSuperiorsPay: 0,
					umemo: null,
					uname: that.updateAgent_name,
					unationalityCode: null,
					unationalityName: null,
					uoperateTime: null,
					uphone: null,
					uphoto: null,
					upollCode: null,
					uprovinceCode: that.updateAgent_addr.provinceCode,
					uprovinceName: that.updateAgent_addr.provinceName,
					uqualifications: null,
					usynopsis: that.updateAgent_desc,
					utel: null,
					utypeId: null,
					uupdate: null,
					uupdateTs: null,
					uvsersionStatus: 0
				},
				ucode: that.authInfo.ucode,
				uid: null
			};
			Api.updateOrganization(_requestData).then(
				(res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateAgent_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},

		// 点击批量删除
		handleBatchDeleteClick() {
			if (this.deleteAgent_ids.length) {
				this.deleteAgent_popup_display = true;
			} else {
				this.$message({
					message: '请勾选要删除的代理商',
					type: 'warning'
				});
			}
		},
		//删除代理
		deleteProxy(row) {
			// this.deleteAgent_ids)
			var _requestData = {
				uEnterpriseId: row.id
			};
			Api.getOrganizationConsumeCount(_requestData).then((res) => {
				if (res.data.success) {
					let arrMap = res.data.data.map((item) => {
						return {
							urcTime: item.urcTime
						};
					});
					if (arrMap.length > 0) {
						const falg = arrMap.every((item) => item.urcTime == 0);
						console.log(falg);
						if (!falg) {
							this.$message.error('剩余次数未用完，删除失败');
							return;
						}
					}

					this.$confirm('此操作将永久删除该代理商, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							// this.$message({
							// 	type: 'success',
							// 	message: '删除成功!'
							// });
							this.deleteOrganization(JSON.stringify([row.id]));
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
				}
			});
		},
		// 表格选择
		handleTableSelectionChange(val) {
			this.deleteAgent_ids = [];
			for (var i = 0; i < val.length; i++) {
				this.deleteAgent_ids.push(val[i].id);
			}
		},
		// 点击删除弹框确定
		handleDeleteAgentPopupConfirmClick() {
			this.deleteAgent_popup_display = false;

			this.deleteOrganization(JSON.stringify(this.deleteAgent_ids));
		},
		// 点击代理商管理员
		handleManageAgentClick(data) {
			this.manageAgent_id = data.id;
			this.manageAgent_popup_display = true;
		},
		// 点击充值
		handleRechargeAgentClick(data) {
			this.rechargeAgent_id = data.id;
			this.rechargeAgent_name = data.name;
			this.rechargeAgent_code = data.code;
			this.rechargeAgent_popup_display = true;
		},
		// 充值成功
		handleRechargeSuccess(msg) {
			this.$message({
				message: msg,
				type: 'success'
			});
			this.rechargeAgent_popup_display = false;
		},
		// 点击消费统计
		handleAgentConsumeCountClick(data) {
			this.agentConsumeCount_id = data.id;
			this.agentConsumeCount_popup_display = true;
		},
		// 点击充值记录
		handleAgentRechargeRecordClick(data) {
			this.agentRechargeRecord_id = data.id;
			this.agentRechargeRecord_code = data.code;
			this.agentRechargeRecord_popup_display = true;
		},
		// 点击消费记录
		handleAgentConsumeRecordClick(data) {
			this.agentConsumeRecord_id = data.id;
			this.agentConsumeRecord_code = data.code;
			this.agentConsumeRecord_popup_display = true;
		},
		/************************ @Function *******************************/
		// 比较开始时间和结束时间
		compareSearchTime() {
			if (this.agent_startTime && this.agent_endTime) {
				var startTime = new Date(this.agent_startTime).getTime(),
					endTime = new Date(this.agent_endTime).getTime();
				if (endTime < startTime) {
					this.agent_endTime = '';
					this.$message.warning('结束时间不能小于开始时间');
				}
			}
		}
	},
	components: {
		AreaChoise,
		Manager,
		Recharge,
		ConsumeCount,
		RechargeRecord,
		ConsumeRecord
	}
};
</script>

<style scoped></style>
